import { Component, Injector, Input, OnInit, forwardRef } from '@angular/core';
import {
  ControlValueAccessor,
  FormGroup,
  NG_VALUE_ACCESSOR,
  NgControl,
} from '@angular/forms';
import { ModelField } from '@app/shared/interfaces/front-end-column';
import { BaseProductFieldComponent } from '../base-product-component/base-product-field.component';
import { CustomAttribute } from '@product/shared/models/AttributeDTO';
import { AiTextGenerationRequest } from '@app/shared/interfaces/ai-text-generation-request';
import { AIService } from '@app/shared/services/AI.service';

@Component({
  selector: 'app-product-field-text',
  templateUrl: './product-field-text.component.html',
  styleUrls: ['./product-field-text.component.less'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProductFieldTextComponent),
      multi: true,
    },
  ],
})
export class ProductFieldTextComponent
  extends BaseProductFieldComponent
  implements ControlValueAccessor
{
  aiLoading: boolean = false;
  value: string | null = null;
  ngControl: NgControl | null = null;
  constructor(private injector: Injector, private aiService: AIService) {
    super(injector);
  }
  onChange: any = (value: string) => {};
  onTouched: any = () => {};
  writeValue(value: any): void {
    this.value = value;
    this.onChange(this.value); 
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  getNgControl() {
    if (!this.ngControl) {
      this.ngControl = this.injector.get(NgControl, null);
    }
  }
  

  get parentFormGroup() {
        this.getNgControl(); 
    if (!this.ngControl || !this.ngControl.control) {
      console.error("control is not defind");
      return null; 
    }
    return this.ngControl?.control?.parent as FormGroup;
  }
  getAIText() {
    this.aiLoading = true;
    let question: string = this.field.AdditionalData?.aigenerationQuestion;
    if (question == null) {
      this.message.error("This attribute doesn't have an AI question");
      this.aiLoading = false;
      return;
    }
    const params = this.route.snapshot.params;
    const id = params['id'];
    const request: AiTextGenerationRequest = {
      attributeId: +this.field.Code,
      objectId: +id,
      objectType: 12,
      includedAttributes: {},
      languageId: this.languageId,
    };

    this.aiService
      .getText(request, question, this.parentFormGroup!, this.controlName)
      .then(() => (this.aiLoading = false));
  }
}
